import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type Theme = 'light' | 'dark' | 'system'

interface ThemeState {
  theme: Theme
  setTheme: (theme: Theme) => void
  initTheme: () => void
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      theme: 'system',
      setTheme: (theme) => set({ theme }),
      initTheme: () => {
        const stored = get().theme
        if (stored) {
          set({ theme: stored })
        }
      },
    }),
    {
      name: 'xmonitor-theme',
    }
  )
)
